import { UI_STRINGS } from '../../functions/language/uistrings';
import { EnergyMetric } from './energy-metric';

export const EnergyMetricLanguageMinimalLabel = {
  [EnergyMetric.kWh]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.KILOWATT_HOURS,
  [EnergyMetric.MWh]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.MEGA_WATT_HOURS,
  [EnergyMetric.GWh]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.GIGA_WATT_HOURS,
  [EnergyMetric.TWh]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.TERA_WATT_HOURS,
  [EnergyMetric.PWh]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.PETA_WATT_HOURS,
  [EnergyMetric.MMBtu]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.MMBTU,
  [EnergyMetric.billionBtu]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.BILLION_BTU,
  [EnergyMetric.trillionBtu]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.TRILLION_BTU,
  [EnergyMetric.quadrillionBtu]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.QUADRILLION_BTU,
  [EnergyMetric.quintillionBtu]: UI_STRINGS.DISPLAY_UNIT_TITLE_MINIMAL.QUINTILLION_BTU,
};
